import axios from '@axios'

export default {
  namespaced: true,
  state: {
    respData: null,
    respDataBank: null,
    respDataPaymentBank: null,
    languageSettings: [],
    isLoadingLanguages: false,
  },
  getters: {
  },
  mutations: {
    GET_CONFIG_APPLICATION(state, payload) {
      state.respData = payload
    },
    GET_BANK_LIST(state, payload) {
      state.respDataBank = payload
    },
    GET_PAYMENT_BANK_LIST(state, payload) {
      state.respDataPaymentBank = payload
    },
    ADD_PAYMENT_BANK_LIST(state, payload) {
      if (state.respDataPaymentBank != null) {
        state.respDataPaymentBank.data.unshift(payload)
        // eslint-disable-next-line operator-assignment
        state.respDataPaymentBank.max = state.respDataPaymentBank.max + 1
      }
    },
    SWITCH_CHANGE(state, item) {
      const nameChild = item.name.split('.')

      if (nameChild.length === 3) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]] = item.status
      } else if (nameChild.length === 2) {
        state.respData[nameChild[0]][nameChild[1]] = item.status
      } else {
        state.respData[item.name] = item.status
      }
    },
    INPUT_CHANGE(state, item) {
      const nameChild = item.name.split('.')

      if (nameChild.length === 2) {
        state.respData[nameChild[0]][nameChild[1]] = item.value
      } else if (nameChild.length === 3) {
        state.respData[nameChild[0]][nameChild[1]][nameChild[2]] = item.value
      } else {
        state.respData[item.name] = item.value
      }
    },
    UPDATE(state, payload) {
      state.respData = payload

    },
    UPDATE_PAYMENT_BANK_LIST(state, payload) {
      const productIndex = state.respDataPaymentBank.data.findIndex(p => p._id === payload._id)
      if (productIndex > -1) {
        Object.assign(state.respDataPaymentBank.data[productIndex], payload)
      } else {
        state.respDataPaymentBank.data.unshift(payload)
      }
    },
    REMOVE_PAYMENT_BANK_LIST(state, id) {
      if (state.respDataPaymentBank != null) {
        const ItemIndex = state.respDataPaymentBank.data.findIndex(p => p._id === id)
        state.respDataPaymentBank.data.splice(ItemIndex, 1)
        // eslint-disable-next-line operator-assignment
        state.respDataPaymentBank.max = state.respDataPaymentBank.max - 1
      }
    },
    // Language settings mutations
    SET_LANGUAGE_SETTINGS(state, languageSettings) {
      state.languageSettings = languageSettings
    },
    UPDATE_LANGUAGE_STATUS(state, { index, enabled }) {
      if (state.languageSettings[index]) {
        state.languageSettings[index].enabled = enabled
      }
    },
    SET_LOADING_LANGUAGES(state, isLoading) {
      state.isLoadingLanguages = isLoading
    },
  },
  actions: {
    get({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/web/application/eCommerce/applicationSettings/get')
          .then(response => {

            commit('GET_CONFIG_APPLICATION', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    inputChange({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/eCommerce/applicationSettings/inputChange', item)
          .then(response => {
            commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    multiSelectChange({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/eCommerce/applicationSettings/multiSelectChange', item)
          .then(response => {
            commit('UPDATE', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    switchChange({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/web/application/eCommerce/applicationSettings/switchChange', item)
          .then(response => {
            commit('SWITCH_CHANGE', item)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    getBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/eCommerce/applicationSettings/getBankList/${item.paymentMethod}`)
          .then(response => {
            commit('GET_BANK_LIST', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    getPaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/web/application/eCommerce/applicationSettings/getPaymentBankList/${item.paymentMethod}?pageSize=${item.pageSize}&currentPage=${item.currentPage}&searchQuery=${item.searchQuery}`)
          .then(response => {
            commit('GET_PAYMENT_BANK_LIST', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    addPaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.post(`/api/web/application/eCommerce/applicationSettings/addPaymentBankList/${item.paymentMethod}`, item)
          .then(response => {
            commit('ADD_PAYMENT_BANK_LIST', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    updatePaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/web/application/eCommerce/applicationSettings/updatePaymentBankList/${item.paymentMethod}`, item)
          .then(response => {
            commit('UPDATE_PAYMENT_BANK_LIST', response.data.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    deletePaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios.put(`/api/web/application/eCommerce/applicationSettings/deletePaymentBankList/${item.paymentMethod}`, item)
          .then(response => {
            commit('REMOVE_PAYMENT_BANK_LIST', item.id)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    switchChangePaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/applicationSettings/switchChangePaymentBankList/${item.paymentMethod}`, item)
          .then(response => {
            // commit('SWITCH_CHANGE', item)
            commit('UPDATE_PAYMENT_BANK_LIST', response.data.data)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // eslint-disable-next-line no-unused-vars
    activatePaymentBankList({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/applicationSettings/activatePaymentBankList/${item.paymentMethod}`, item)
          .then(response => {
            // commit('SWITCH_CHANGE', item)
            // commit('UPDATE_PAYMENT_BANK_LIST', response.data.data)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    activatePaypal({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/paypal/activate`, item)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    activateOmise({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/omise/activate`, item)
          .then(response => {
            // Update the local state
            commit('SWITCH_CHANGE', { name: 'omise.activate', status: item.status })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    confirmPaypal({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/paypal/confirm`, item)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // WhatsApp integrations
    // Enable/disable WhatsApp service via application settings
    activateWhatsapp({ commit }, item) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/whatsapp/activate`, item)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Fetch QR code or connection data to pair WhatsApp device/session
    connectWhatsapp({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/web/application/eCommerce/whatsapp/connect`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Check WhatsApp session status
    whatsappStatus() {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/web/application/eCommerce/whatsapp/status`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Disconnect WhatsApp session
    disconnectWhatsapp() {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/web/application/eCommerce/whatsapp/disconnect`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    // Language management actions
    getApplicationLanguages({ commit }, { applicationId, companyId, franchiseId }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING_LANGUAGES', true)
        
        // Fetch both system config and application config
        Promise.all([
          // Get system config languages
          axios.get('/api/system/get'),
          // Get application config languages
          axios.get('/api/system/getApplicationLanguages', {
            params: { applicationId, companyId, franchiseId }
          })
        ])
        .then(([systemResponse, appResponse]) => {
          let finalLanguageSettings = []
          
          // Get system languages (fallback)
          if (systemResponse.data && systemResponse.data.data && systemResponse.data.data.language) {
            finalLanguageSettings = systemResponse.data.data.language.map(lang => ({
              ...lang,
              enabled: lang.enabled !== false, // Default to true if not specified
              source: 'system' // Mark as from system config
            }))
          }
          
          // Override with application-specific languages if available
          if (appResponse.data && appResponse.data.data && appResponse.data.data.language) {
            const appLanguages = appResponse.data.data.language
            
            // Merge application languages with system languages
            appLanguages.forEach(appLang => {
              const existingIndex = finalLanguageSettings.findIndex(sysLang => sysLang.lang === appLang.lang)
              
              if (existingIndex >= 0) {
                // Update existing language with application settings
                finalLanguageSettings[existingIndex] = {
                  ...finalLanguageSettings[existingIndex],
                  ...appLang,
                  enabled: appLang.enabled !== false,
                  source: 'application' // Mark as from application config
                }
              } else {
                // Add new language from application config
                finalLanguageSettings.push({
                  ...appLang,
                  enabled: appLang.enabled !== false,
                  source: 'application'
                })
              }
            })
          }
          
          // If no languages found, use defaults
          if (finalLanguageSettings.length === 0) {
            finalLanguageSettings = [
              { name: 'Thai', lang: 'th', enabled: true, source: 'default' },
              { name: 'English', lang: 'en', enabled: true, source: 'default' },
            ]
          }
          
          commit('SET_LANGUAGE_SETTINGS', finalLanguageSettings)
          commit('SET_LOADING_LANGUAGES', false)
          resolve(appResponse)
        })
        .catch(error => {
          commit('SET_LOADING_LANGUAGES', false)
          
          // Try to get at least system config on error
          axios.get('/api/system/get')
            .then(systemResponse => {
              if (systemResponse.data && systemResponse.data.data && systemResponse.data.data.language) {
                const systemLanguages = systemResponse.data.data.language.map(lang => ({
                  ...lang,
                  enabled: lang.enabled !== false,
                  source: 'system'
                }))
                commit('SET_LANGUAGE_SETTINGS', systemLanguages)
              } else {
                // Set default languages on complete failure
                const defaultLanguages = [
                  { name: 'Thai', lang: 'th', enabled: true, source: 'default' },
                  { name: 'English', lang: 'en', enabled: true, source: 'default' },
                ]
                commit('SET_LANGUAGE_SETTINGS', defaultLanguages)
              }
            })
            .catch(() => {
              // Set default languages on complete failure
              const defaultLanguages = [
                { name: 'Thai', lang: 'th', enabled: true, source: 'default' },
                { name: 'English', lang: 'en', enabled: true, source: 'default' },
              ]
              commit('SET_LANGUAGE_SETTINGS', defaultLanguages)
            })
          
          reject(error)
        })
      })
    },
    updateApplicationLanguages({ commit }, { language, applicationId, companyId, franchiseId }) {
      return new Promise((resolve, reject) => {
        axios
          .put('/api/system/updateLanguages', {
            language,
            applicationId,
            companyId,
            franchiseId
          })
          .then(response => {
            // Update the language settings in store
            commit('SET_LANGUAGE_SETTINGS', language)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
